import React, { ComponentProps, useState } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { Column, Row, SelectParam } from '../../../_lib/Form2';
import {
  AreaPageTypeSelect,
  AreaPageTypeValue,
} from '../../../_lib/Form2/standardForms/CreateEditPageMembershipMatchingRuleForm/partials/AreaPageTypeSelect';
import { PageMembershipMatchingRulesSiteMapElement, SiteMap } from '../partial/SiteMap';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useSearchParams } from 'react-router';

type PageMembershipMatchingRulesSiteMapProps = {
  areaPageTypes: SelectParam<'areaPageType', { value: AreaPageTypeValue }>,
  areaSiteMap: Record<
    AreaPageTypeValue,
    PageMembershipMatchingRulesSiteMapElement[]
  >
};

function PageMembershipMatchingRulesSiteMap({ areaPageTypes, areaSiteMap }: PageMembershipMatchingRulesSiteMapProps) {
  const { t } = useSonTranslation('PageMembershipMatchingRuleList');
  const [searchParams] = useSearchParams();
  const [selectedAreaPageType, setSelectedAreaPageType] =
    useState<AreaPageTypeValue>((searchParams.get('pageType') || areaPageTypes.value) as AreaPageTypeValue);

  return (
    <>
      <div className="page-membership-matching-rule-list__site-map-select-container">
        <Row modifier={['row--grid-3-columns', 'no-margin']}>
          <Column>
            <AreaPageTypeSelect
              areaPageTypeParam={areaPageTypes}
              defaultValue={selectedAreaPageType}
              onChange={event => setSelectedAreaPageType(event.target.value as AreaPageTypeValue)}
            />
          </Column>
        </Row>
      </div>
      <div className="page-membership-matching-rule-list__site-map-container">
        {selectedAreaPageType
          ? <SiteMap elements={areaSiteMap[selectedAreaPageType]} />
          : <ContentMessage text={t('viewNoEntriesSiteMap')} />}
      </div>
    </>
  );
}

export const PageMembershipMatchingRulesSiteMapView = asFetchableView(PageMembershipMatchingRulesSiteMap);
export type PageMembershipMatchingRulesSiteMapView = ComponentProps<typeof PageMembershipMatchingRulesSiteMap>;
